import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';
import type { SpreadsheetColumnTypeMap } from '../../../constants/spreadsheetColumnTypes';
import CSVPreviewTable from './CSVPreviewTable';
import ColumnMappingComponent from '../../Prospect/ColumnMappingComponent';

interface PreviewMappingStepProps {
  rawCsvRows: string[][];
  headerRowOffset: number;
  onHeaderRowChange: (rowIndex: number) => void;
  columnsDefinition: GridColDef[];
  existingColumnTypes?: Record<string, string>;
  detectedColumns: string[];
  loadingColumns: boolean;
  onMappingChange: (mapping: Record<string, string | null>) => void;
  onColumnTypesChange?: (columnTypes: SpreadsheetColumnTypeMap) => void;
}

const PreviewMappingStep: React.FC<PreviewMappingStepProps> = ({
  rawCsvRows,
  headerRowOffset,
  onHeaderRowChange,
  columnsDefinition,
  existingColumnTypes,
  detectedColumns,
  loadingColumns,
  onMappingChange,
  onColumnTypesChange
}) => {
  return (
    <Box>
      <CSVPreviewTable
        rawCsvRows={rawCsvRows}
        headerRowOffset={headerRowOffset}
        onRowClick={onHeaderRowChange}
      />
      {loadingColumns ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <ColumnMappingComponent
          existingColumns={columnsDefinition}
          existingColumnTypes={existingColumnTypes}
          detectedColumns={detectedColumns}
          protectedFields={[]}
          onConfirm={() => {}}
          onCancel={() => {}}
          triggeredFromProspectPage={false}
          hideButtons={true}
          onMappingChange={onMappingChange}
          onColumnTypesChange={onColumnTypesChange}
        />
      )}
    </Box>
  );
};

export default PreviewMappingStep;
